import "./scss/index.scss";
import "react-toastify/dist/ReactToastify.css";

import "./lib/dayjs";
import "./lib/i18n";

import { createRoot } from "react-dom/client";

import App from "./containers/Root";
import { getDomain } from "./lib/common/getDomain";

const updateMetaTags = () => {
  const domain = getDomain(true);

  const domainConfig: Record<string, { title: string; favicon: string }> = {
    "cloud.frontassist.eu": {
      title: "FrontAssist",
      favicon: "/frontassist.ico",
    },
    "centerparcs.castit.nl": {
      title: "Center Parcs",
      favicon: "/centerparcs.ico",
    },
  };

  const config = domainConfig[domain] || {
    title: "Digital Reception",
    favicon: "/digitalreception.ico",
  };

  document.title = config.title;

  const favicon = document.querySelector("link[rel='icon']");
  if (favicon) {
    favicon.setAttribute("href", config.favicon);
  }
};

updateMetaTags();

const container = document.getElementById("root");

const root = createRoot(container!);

root.render(<App />);
